<template>
  <div class="forgot-password">
    <div class="layout">
      <el-card shadow="hover">
        <img src="@/assets/images/ilogo.png"  alt />
        <div class="content">
          <div class="form">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="formRequestResetPassword"
              v-if="!emailResetPassword"
            >
              <h2 class="">{{$t('auth.forgotPassword.title')}}</h2>
              <P class="mt-1">{{$t('auth.forgotPassword.description')}}</P>
              <el-form-item prop="email">
                <el-input
                  type="email"
                  v-model="ruleForm.email"
                  autocomplete="off"
                  placeholder="Email"
                ></el-input>
              </el-form-item>
              <el-form-item class="mb-0 mt-2">
                <el-button
                  type="primary"
                  class="w-100"
                  :disabled="isRequestResetPassword"
                  @click="!isRequestResetPassword ? handleRequestResetPassword(ruleForm) : null"
                >
                  {{$t('auth.forgotPassword.btn')}}
                  <i
                    class="el-icon-loading"
                    v-if="isRequestResetPassword"
                  ></i>
                </el-button>
              </el-form-item>
              <a
                href="/login"
                class="text-primary text-center hover-text-underline d-block mt-1"
              >{{$t('auth.forgotPassword.loginLink')}}</a>
            </el-form>
            <div class="account-recovery-notify" v-if="emailResetPassword">
              <h2 class="">{{$t('auth.forgotPassword.title')}}</h2>
              <P class="mt-1" v-html="$t('auth.forgotPassword.notice', {email: emailResetPassword})"></P>
              <el-button
                type="primary"
                class="w-100 mt-2"
                @click="goBackLoginPage()"
              >{{$t('auth.forgotPassword.loginLink')}}</el-button>
            </div>
          </div>
          <img src="@/assets/images/forgot.jpg" alt />
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import authServices from '@/services/auth'
export default {
  name: 'ForgotPassword',
  data () {
    return {
      locale: localStorage.locale,
      isRequestResetPassword: false,
      emailResetPassword: '',
      ruleForm: {
        email: '',
        pass: '',
        confirmPass: ''
      },
      rules: {
        email: [
          { required: true, message: this.$t('auth.forgotPassword.email.required'), trigger: 'blur' },
          { type: 'email', message: this.$t('auth.forgotPassword.email.type'), trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    handleRequestResetPassword (form) {
      this.$refs.formRequestResetPassword.validate((valid) => {
        if (valid) {
          this.isRequestResetPassword = true
          authServices.requestResetPassword(form.email)
            .then(res => {
              this.emailResetPassword = form.email
              this.isRequestResetPassword = false
            })
            .catch(e => {
              console.log(e)
              this.isRequestResetPassword = false
            })
        }
      })
    },
    goBackLoginPage () {
      this.$router.push({name: 'login'})
    }
  },
  mounted () {
    this.$emit('setLocale', this.locale)
  }
}
</script>

<style lang="scss" scoped>
.forgot-password {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
  .el-card {
    width: 700px;
    margin: 0 auto;
    border-radius: 20px;
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .form {
        width: 50%;
      }
      img {
        width: 45%;
      }
    }
  }
}
@media (max-width: 767px) {
  .forgot-password {
    padding: 20px;
    .layout {
      width: 100%;
      .el-card {
        width: 100%;
      }
    }
  }
}
@media (max-width: 480px) {
  .forgot-password {
    padding: 20px;
    .layout {
      .el-card {
        .el-form {
          width: 100%;
        }
        img {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/forgot-password.vue